import React from 'react';
import { motion } from 'framer-motion';
import { FileSpreadsheet, Table, Edit3, Printer } from 'lucide-react';
export function ProductOverview() {
  return <section className="py-12 bg-nutri-dark text-white" data-id="element-251">
      <div className="container mx-auto px-4 text-center" data-id="element-252">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 backdrop-blur-sm" data-id="element-253">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 leading-tight" data-id="element-254">
            NUTRIPRO KIT — El sistema definitivo de planillas profesionales para
            nutricionistas
          </h2>

          <div className="flex flex-wrap justify-center items-center gap-2 md:gap-4 mb-8 text-sm md:text-base" data-id="element-255">
            {['+50 planillas', '2 formatos', 'Editables', 'Imprimibles'].map((badge, i) => <span key={i} className="bg-nutri-medium/40 border border-nutri-mint/30 px-3 py-1 md:px-4 md:py-1.5 rounded-full font-semibold text-nutri-mint" data-id="element-256">
                  {badge}
                </span>)}
          </div>

          <div className="flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-257">
            {[{
            icon: Table,
            label: 'Excel'
          }, {
            icon: FileSpreadsheet,
            label: 'Google Sheets'
          }, {
            icon: Edit3,
            label: 'Editables'
          }, {
            icon: Printer,
            label: 'Imprimibles'
          }].map((item, index) => <div key={index} className="flex items-center gap-2" data-id="element-258">
                <div className="bg-white/10 p-2 rounded-lg" data-id="element-259">
                  <item.icon size={20} className="text-nutri-mint" data-id="element-260" />
                </div>
                <span className="font-medium text-sm md:text-base" data-id="element-261">
                  {item.label}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}